/**************************************************
 * Nombre:       Dialogo_Felicitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Avatar, Button, Grid, Typography} from "@mui/material";
import {WhatsApp} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import logo from '../../Recursos/logo_redondo.svg'
import {obtenerObjLocal} from "../../Servicios/Local/obtenerObjLocal";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";


const Dialogo_Felicitaciones = ({datos, cerrar, realizado}) => {
    const {sCell} = useResponsive()
    const [camapana, setCamapana] = useState({})


    useEffect(() => {

        let campa = obtenerObjLocal({key: 'campana'})
        setCamapana(campa)

    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -4}}>
                <Typography sx={{
                    fontSize: sCell ? 24 : 24,
                    fontWeight: 600,
                    color: '#1B0B3B',
                    textTransform: 'uppercase',
                    lineHeight: 1.2,
                    textAlign: 'center'
                }}>
                    {datos.tituloFin} <span
                    style={{color: '#9049F5'}}> {datos.rosadoTituloFin} </span>

                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, px: 3}}>
                <Typography sx={{color: "#000", fontWeight: 300, fontSize: 14, textAlign: 'center', lineHeight: 1.3}}>
                    {datos.parrafoFin}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                <Avatar src={camapana.imgUsuario ? camapana.imgUsuario : logo} sx={{width: 64, height: 64}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontSize: 18}}>{camapana.nombreUsuario}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => iniciarChatWass({
                        numero: camapana.celular,
                        nombre: camapana.nombreUsuario,
                        nombreFunnel: datos.nombre
                    })}
                    startIcon={<WhatsApp/>}
                    sx={{borderRadius: 8, py: 1.5, px: 4}}
                >COMUNICARME AHORA</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Felicitaciones